export default __webpack_public_path__ + "static/media/pinkShirts.b91f4e6f.jpg";